var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 5.1114L13.7175 6.35755V3.78747C13.7175 3.1906 13.2197 2.70532 12.6075 2.70532H2.34C1.72777 2.70532 1.23 3.1906 1.23 3.78747V13.5268C1.23 14.1236 1.72777 14.6089 2.34 14.6089H12.6075C13.2197 14.6089 13.7175 14.1236 13.7175 13.5268V10.9567L15.9375 12.2028C16.3069 12.4108 16.77 12.1504 16.77 11.7361V5.57976C16.77 5.16382 16.3069 4.90342 15.9375 5.1114ZM12.4688 13.3915H2.47875V3.92273H12.4688V13.3915ZM15.5212 10.5678L13.7175 9.55664V7.75927L15.5212 6.74645V10.5678ZM3.7275 6.08702H5.67C5.74631 6.08702 5.80875 6.02615 5.80875 5.95175V5.14014C5.80875 5.06575 5.74631 5.00488 5.67 5.00488H3.7275C3.65119 5.00488 3.58875 5.06575 3.58875 5.14014V5.95175C3.58875 6.02615 3.65119 6.08702 3.7275 6.08702Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.bf8665fe.svg";
export { ForwardRef as ReactComponent };